<!-- https://www.figma.com/design/K7vDg6el3Bz7MHUdlMREDj/Credit-Conversion-Statuses?node-id=2027-58&p=f&m=dev -->
<template>
  <CardLayout
    button-href="/dashboard"
    button-text="Return to dashboard"
    title="Credits successfully added to transcript!"
    :body="body"
    :button-data-layer-event="dataLayerEvent"
    :button-disabled="false"
  >
    <template #art>
      <ArtSuccess />
    </template>
  </CardLayout>
</template>

<script lang="ts">
import CardLayout from '../ui/CardLayout.vue';
import ArtSuccess from './ArtSuccess.vue';

export default {
  name: 'CardSuccess',
  components: {
    CardLayout,
    ArtSuccess
  },
  data() {
    return {
      body: {
        blocks: [
          {
            lines: [
              'Congratulations! Your course has been successfully added to your transcript for ASU credit.',
              'Please visit your MyASU page to view your credits and request a transcript.'
            ]
          }
        ]
      }
    };
  },
  computed: {
    dataLayerEvent() {
      return {
        event: 'link',
        action: 'click',
        name: 'onclick',
        type: 'internal link',
        region: 'main content',
        section: 'credits successfully added to transcript',
        text: 'return to dashboard',
        component: 'success card'
      };
    }
  }
};
</script>
